import { ITemplate } from './../../template-preview/template-preview.component';
import { Component, OnInit, AfterViewInit, ElementRef, Input } from "@angular/core";
import { NgbActiveModal, NgbModal, NgbModalRef, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl } from "@angular/forms";
import { getChartColorMap } from "../../achart/achart.colors";
import { ColorEvent } from "ngx-color";
import * as $ from "jquery";
import { AChartComponent } from "../../achart/achart.component";
import { WizardIndicatorsData } from '../../../model/wizardindicators.data';

@Component({
    selector: "chartOptionsModal",
    template: require('./ChartOptionsModal.component.html'),
    styles: [require('./ChartOptionsModal.component.scss')]
})
export class ChartOptionsModalComponent implements OnInit, AfterViewInit {
    @Input()
    form: FormGroup;

    BackgroundColor: string='';
    FontColor: string='';
    GridColor: string='';
    MinorGridColor: string='';
    AxisColor: string='';
    LineSeriesColor: string='';
    WizardLineSeriesColor: string='';
    CandleStickSerieRisingColor:string='';
    CandleStickSerieFallingColor:string='';
    CandleStickSerieBorderColor:string='';
    CrosshairColor = '';

    templateNameWindow = false;
    templateMode = false;
    template?: ITemplate;
    editMode = false;

    constructor(public activeModal: NgbActiveModal, protected element: ElementRef) {
        this.form = new FormGroup({
          "BackgroundColor":new FormControl(),
          "FontColor":new FormControl(),
          "GridColor":new FormControl(),
          "MinorGridColor":new FormControl(),
          "AxisColor":new FormControl(),
          "LineSerieColor":new FormControl(),
          "WizardLineSeriesColor":new FormControl(),
          "CandleStickSerieRisingColor":new FormControl(),
          "CandleStickSerieFallingColor":new FormControl(),
          "CandleStickSerieBorderColor":new FormControl(),
          "CrosshairColor": new FormControl()
        });
    }

    CrosshairColorChange($event: ColorEvent): void {
      this.CrosshairColor=$event.color.hex;
      this.form.value["CrosshairColor"]=$event.color.hex;
  }

    BackgroundColorChange($event: ColorEvent): void {
        this.BackgroundColor=$event.color.hex;
        this.form.value["BackgroundColor"]=$event.color.hex;
    }

    FontColorChange($event: ColorEvent): void {
      this.FontColor=$event.color.hex;
      this.form.value["FontColor"]=$event.color.hex;
    }
    GridColorChange($event: ColorEvent): void {
      this.GridColor=$event.color.hex;
      this.form.value["GridColor"]=$event.color.hex;
    }
    MinorGridColorChange($event: ColorEvent): void {
      this.MinorGridColor=$event.color.hex;
      this.form.value["MinorGridColor"]=$event.color.hex;
    }
    AxisColorChange($event: ColorEvent): void {
      this.AxisColor=$event.color.hex;
      this.form.value["AxisColor"]=$event.color.hex;
    }
    LineSeriesColorChange($event: ColorEvent): void {
      this.LineSeriesColor=$event.color.hex;
      this.form.value["LineSeriesColor"]=$event.color.hex;
    }

    WizardLineSeriesColorChange($event: ColorEvent): void {
      this.WizardLineSeriesColor=$event.color.hex;
      this.form.value["WizardLineSeriesColor"]=$event.color.hex;
    }

    CandleStickSerieRisingColorChange($event: ColorEvent): void {
      this.CandleStickSerieRisingColor=$event.color.hex;
      this.form.value["CandleStickSerieRisingColor"]=$event.color.hex;
    }

    CandleStickSerieFallingColorChange($event: ColorEvent): void {
      this.CandleStickSerieFallingColor=$event.color.hex;
      this.form.value["CandleStickSerieFallingColor"]=$event.color.hex;
    }

    CandleStickSerieBorderColorChange($event: ColorEvent): void {
      this.CandleStickSerieBorderColor=$event.color.hex;
      this.form.value["CandleStickSerieBorderColor"]=$event.color.hex;
    }

    ngAfterViewInit(): void {
      this.form.value.BackgroundColor=this.BackgroundColor;
      this.form.value.FontColor=this.FontColor;
      this.form.value.GridColor=this.GridColor;
      this.form.value.MinorGridColor=this.MinorGridColor;
      this.form.value.AxisColor=this.AxisColor;

      this.form.value.LineSeriesColor=this.LineSeriesColor;
      this.form.value.WizardLineSeriesColor=this.WizardLineSeriesColor;
      this.form.value.CandleStickSerieRisingColor=this.CandleStickSerieRisingColor;
      this.form.value.CandleStickSerieFallingColor=this.CandleStickSerieFallingColor;
      this.form.value.CandleStickSerieBorderColor=this.CandleStickSerieBorderColor;
      this.form.value.CrosshairColor = this.CrosshairColor;
    }

    ngOnInit() {
      this.form.value.BackgroundColor=this.BackgroundColor;
      this.form.value.FontColor=this.FontColor;
      this.form.value.GridColor=this.GridColor;
      this.form.value.MinorGridColor=this.MinorGridColor;
      this.form.value.AxisColor=this.AxisColor;
      this.form.value.LineSeriesColor=this.LineSeriesColor;
      this.form.value.WizardLineSeriesColor=this.WizardLineSeriesColor;
      this.form.value.CandleStickSerieRisingColor=this.CandleStickSerieRisingColor;
      this.form.value.CandleStickSerieFallingColor=this.CandleStickSerieFallingColor;
      this.form.value.CandleStickSerieBorderColor=this.CandleStickSerieBorderColor;
      this.form.value.CrosshairColor = this.CrosshairColor;
    }

    finish()
    {
      const templateName = this.form.value.templateName;
      if(this.templateMode && (templateName == null || templateName.length < 1))
      {
        if(this.editMode && this.template)
          this.form.value.templateName = this.template.name;
          
        this.templateNameWindow = true;
        return;
      }
      this.activeModal.close(Object.assign(this.form, {editMode: this.editMode, template: this.template}));
    }

    initForm(achart: AChartComponent[]){      
    
      this.BackgroundColor= achart[0].BackgroundColor.split(' ')[0];
      this.FontColor= achart[0].FontColor.split(' ')[0];
      this.GridColor= achart[0].GridColor.split(' ')[0];
      this.MinorGridColor= achart[0].MinorGridColor.split(' ')[0];
      this.AxisColor= achart[0].AxisColor.split(' ')[0];
      this.LineSeriesColor= achart[0].LineSeriesColor.split(' ')[0];
      this.WizardLineSeriesColor=achart[0].WizardLineSeriesColor.split(' ')[0];
      this.CandleStickSerieRisingColor= achart[0].CandleStickSerieRisingColor.split(' ')[0];
      this.CandleStickSerieFallingColor= achart[0].CandleStickSerieFallingColor.split(' ')[0];
      this.CandleStickSerieBorderColor= achart[0].CandleStickSerieBorderColor.split(' ')[0];
      this.CrosshairColor = achart[0].Config.CrosshairColor;

      this.form.value.BackgroundColor=this.BackgroundColor;
      this.form.value.FontColor=this.FontColor;
      this.form.value.GridColor=this.GridColor;
      this.form.value.MinorGridColor=this.MinorGridColor;
      this.form.value.AxisColor=this.AxisColor;
      this.form.value.LineSeriesColor=this.LineSeriesColor;
      this.form.value.WizardLineSeriesColor=this.WizardLineSeriesColor;

      this.form.value.CandleStickSerieRisingColor=this.CandleStickSerieRisingColor;
      this.form.value.CandleStickSerieFallingColor=this.CandleStickSerieFallingColor;
      this.form.value.CandleStickSerieBorderColor=this.CandleStickSerieBorderColor;
      this.form.value.CrosshairColor = this.CrosshairColor;
    }

    initFormTemplate(template: ITemplate, editMode = false)
    {
      this.templateMode = true;
      this.template = template;
      this.editMode = editMode;
      this.form.value.templateName = null;
      
      if(template.background) 
      {
          this.BackgroundColor = template.background;
      }
      if(template.axis)
      {
          this.AxisColor = template.axis;
      }
      if(template.grid)
      {
          this.GridColor = template.grid;
      }
      if(template.minorGrid)
      {
          this.MinorGridColor = template.minorGrid;
      }
      if(template.chartingPriceline)
      {
          this.LineSeriesColor = template.chartingPriceline;
      }
      if(template.candleBorder)
      {
          this.CandleStickSerieBorderColor = template.candleBorder;
      }
      if(template.bearishCandle)
      {
          this.CandleStickSerieFallingColor = template.bearishCandle;
      }
      if(template.bullishCandle)
      {
          this.CandleStickSerieRisingColor = template.bullishCandle;
      }
      if(template.font)
      {
        this.FontColor = template.font;
      }
      if(template.crosshair)
      {
        this.CrosshairColor = template.crosshair;
      }
    }
}

export function ShowChartOptionsModal(achart: AChartComponent[], modalService: NgbModal) {
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: "dark-modal",
        //size:"sm"
    };
    let m: NgbModalRef = modalService.open(ChartOptionsModalComponent, opt);
    (<ChartOptionsModalComponent>m.componentInstance).initForm(achart);

    m.result.then((formGroup: FormGroup)=>{
      
      achart.forEach(c=>{
        c.BackgroundColor=`${formGroup.value.BackgroundColor}`;
        c.FontColor=`${formGroup.value.FontColor}`;
        c.GridColor=`${formGroup.value.GridColor}`;
        c.MinorGridColor=`${formGroup.value.MinorGridColor}`;
        c.AxisColor=`${formGroup.value.AxisColor}`;
        c.LineSeriesColor=`${formGroup.value.LineSeriesColor}`;
        c.WizardLineSeriesColor=`${formGroup.value.WizardLineSeriesColor}`;
        c.CandleStickSerieBorderColor=`${formGroup.value.CandleStickSerieBorderColor}`;
        c.CandleStickSerieFallingColor=`${formGroup.value.CandleStickSerieFallingColor}`;
        c.CandleStickSerieRisingColor=`${formGroup.value.CandleStickSerieRisingColor}`;
        c.CrosshairColor = `${formGroup.value.CrosshairColor}`;

        c.Config.BackgroundColor=`${formGroup.value.BackgroundColor}`;
        c.Config.FontColor=`${formGroup.value.FontColor}`;
        c.Config.GridColor=`${formGroup.value.GridColor}`;
        c.Config.MinorGridColor=`${formGroup.value.MinorGridColor}`;
        c.Config.AxisColor=`${formGroup.value.AxisColor}`;
        c.Config.LineSeriesColor=`${formGroup.value.LineSeriesColor}`;
        c.Config.WizardLineSeriesColor=`${formGroup.value.WizardLineSeriesColor}`;
        c.Config.CandleStickSerieBorderColor=`${formGroup.value.CandleStickSerieBorderColor}`;
        c.Config.CandleStickSerieFallingColor=`${formGroup.value.CandleStickSerieFallingColor}`;
        c.Config.CandleStickSerieRisingColor=`${formGroup.value.CandleStickSerieRisingColor}`;
        
      }) 
    }).catch(reason=>{
        console.error(reason);
        
    });
} 
